import React, {
  useEffect,
  useMemo,
  useCallback,
  useState
} from 'react';
import SplitterLayout from 'react-splitter-layout';
import { formatMessage } from 'devextreme/localization';
import { Column } from 'devextreme-react/data-grid';
import DataGridMVP from '../DataGridMVP';
import columnDataGridHistoryMaster from './columnDataGridHistoryMaster';
import columnDataGridHistoryDetails from './columnDataGridHistoryDetails';
import style from './infohistory.module.scss';

const InfoHistory = ({
  userReducer: { id },
  pieceInfoReducer: { details },
  infoHistoryReducer,
  getInfoHistory
}) => {
  const [dataDetails, setDataDetails] = useState(null);
  useEffect(() => {
    if (id && details && details.pieceNumId) {
      getInfoHistory({ pieceNumId: details.pieceNumId });
    }
  }, [
    details,
    getInfoHistory,
    id
  ]);

  const onSelectUser = useCallback(({ selectedRowsData }) => {
    if (selectedRowsData && selectedRowsData.length) {
      setDataDetails(selectedRowsData[0].details);
    } else {
      setDataDetails(null);
    }
  }, []);

  const renderHistoryMaster = useMemo(() => (
    <DataGridMVP className="shipment"
                 setStateStoringName="dataGridHistoryMaster"
                 keyExpr="actionNumId"
                 setDataGridInstance={() => {}}
                 visibleButtonDateRangePicker={false}
                 visibleSummary={false}
                 visibleGroupPanel={false}
                 visibleInfoIcon={false}
                 visibleButtonAddResponsiblePerson={false}
                 dataSource={infoHistoryReducer.details}
                 loadingData={infoHistoryReducer.loading}
                 filterDataGrid
                 selectionMode="single"
                 onSelectionChanged={onSelectUser}
    >
      {
        columnDataGridHistoryMaster.map(
          (item) => (
            <Column dataField={item.dataField}
                    caption={formatMessage('textTableHistory')[item.dataField]}
                    visible={!item.notVisible}
                    allowSearch={false}
                    allowFiltering
                    cellRender={item.cellRender}
                    key={item.dataField}
                    dataType={item.dataType}
                    cssClass={item.cssClass}
                    width={item.width ? item.width : undefined}
            />
          )
        )
      }
    </DataGridMVP>
  ), [infoHistoryReducer.details, infoHistoryReducer.loading, onSelectUser]);

  const renderHistoryDetails = useMemo(() => (
    <DataGridMVP className="shipment"
                 setStateStoringName="dataGridHistoryDetails"
                 keyExpr="attrbNumId"
                 setDataGridInstance={() => {}}
                 visibleButtonDateRangePicker={false}
                 visibleSummary={false}
                 visibleGroupPanel={false}
                 visibleInfoIcon={false}
                 visibleButtonAddResponsiblePerson={false}
                 dataSource={dataDetails}
                 loadingData={false}
                 filterDataGrid
                 selectionMode="single"
    >
      {
        columnDataGridHistoryDetails.map(
          (item) => (
            <Column dataField={item.dataField}
                    caption={formatMessage('textTableHistory')[item.dataField]}
                    visible={!item.notVisible}
                    allowSearch={false}
                    allowFiltering
                    cellRender={item.cellRender}
                    key={item.dataField}
                    dataType={item.dataType}
                    cssClass={item.cssClass}
                    width={item.width ? item.width : undefined}
            />
          )
        )
      }
    </DataGridMVP>
  ), [dataDetails]);

  return (
    <div className={style.containing}>
      <SplitterLayout>
        <div>
          <p><b>{formatMessage('textInfoTab').historyPiece}</b></p>
          { renderHistoryMaster }
        </div>
        <div>
          <p><b>{formatMessage('textInfoTab').details}</b></p>
          { renderHistoryDetails }
        </div>
      </SplitterLayout>
    </div>
  );
};

export default InfoHistory;
